<template>
  <mdb-container class="gp-has-header">
    <banner-small v-if="currentGroup && domainName=='member'" :group="currentGroup" title="Custom Fields"/>
    <div class="text-left">
      <div v-if="showMain">
        <h3>{{ pageTitle }}</h3>
        <mdb-btn size="sm" rounded @click="addField" icon="plus-circle">Add field</mdb-btn>
        <mdb-btn size="sm" rounded @click="$router.push($route.query.return)" v-if="$route.query.return">Return to {{domainNameProper}}</mdb-btn>
        <mdb-btn v-if="helpText && !showInstructions" icon="question" rounded size="sm" @click="showInstructions=true">
          Explain This
          Page
        </mdb-btn>

        <mdb-card v-if="showInstructions" class="mb-4">
          <mdb-card-header><h5>About Custom Fields</h5></mdb-card-header>
          <mdb-card-body v-html="helpText"/>
          <mdb-card-footer>
            <mdb-btn v-if="showInstructions" rounded size="sm" @click="showInstructions=false">Hide Help</mdb-btn>
          </mdb-card-footer>

        </mdb-card>

        <div v-if="fields.length>0">
          <mdb-tbl responsive striped>
            <mdb-tbl-head class="secondary-color text-white">
              <tr>
                <th>Field</th>
                <th>Type</th>
                <th># Answers</th>
                <th></th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr :key="i" v-for="(field,i) in fields">
                <td>{{ field.fieldName }}</td>
                <td>{{ translateFieldType(field.type) }}</td>
                <td>{{ field.answerCount}}</td>
                <td>
                  <mdb-btn @click="editfield(field)" floating icon="pencil" size="sm" tag="a"/>
                  <mdb-btn @click="deleteField(field)" floating icon="trash" color="danger" size="sm" tag="a"/>
                  <mdb-btn v-if="domainName == 'member' && field.userMayUpdate && field.answerCount > 0"
                           title="Force Re-Answer"
                           @click="forceReAnswer(field)" floating icon="recycle" color="warning" size="sm" tag="a"/>
                </td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </div>
        <div v-if="fields.length==0">
          No fields set up.
        </div>
      </div>

      <div v-if="showEdit">
        <mdb-card class="mb-4">
          <mdb-card-header>
            <h3>Edit Field</h3>
          </mdb-card-header>
          <mdb-card-body>
            <mdb-btn size="sm" rounded icon="arrow-left" @click="cancelEditing">Back to List</mdb-btn>
            <mdb-input label="Name" placeholder="Name" required type="text" v-model="editing.fieldName"/>
            <mdb-input label="Description" placeholder="Field Description" type="text" v-model="editing.description"/>
            <mdb-input :step="1" :min="0" label="Sequence #" placeholder="Sequence Number" type="number" required
                       v-model="editing.seqNum"/>
            <gp-select :dataObj="editing" :possible-values="fieldTypes" :required="true"
                       :disabled="editing.id != null"
                       label="Field Type" propertyName="type"/>
            <div id="picklist-setup" v-if="editing.type == 'PICKLIST'">
              <label>Possible Values</label>
              <mdb-chip-input :chips="editing.pickListValues"/>
              <div class="text-info small">Press the enter key to accept a valid value</div>
            </div>
            <gp-select v-if="showWhoCanView" :dataObj="editing" :possible-values="viewers" :required="true"
                       label="Who Can View" propertyName="whoCanView"/>

            <mdb-input type="checkbox" id="required" name="required" v-model="editing.required" label="Required"/>
            <mdb-input type="checkbox" id="expireWithSubscription" name="expireWithSubscription"
                       v-model="editing.expireWithSubscription"
                       v-if="domainName=='member'"
                       label="Member must re-answer when subscription expires"/>
            <mdb-input v-if="showUserMayUpdate" type="checkbox" id="userMayUpdate" name="userMayUpdate"
                       v-model="editing.userMayUpdate" :label="userMayUpdateLabel"/>

            <div v-if="editing.userMayUpdate" class="mt-4">
              <h4>Help Text For {{ domainNameProper }}</h4>
              <div class="text-info small" v-if="domainName=='member'">
                The field name is often not enough information for a member to know what you are asking. If you put in text below,
                this will show instead of the field name when your members are asked to complete this data. For example, you may name
                the field "Years Experience", but may want to ask your members something like "How long have been weaving baskets under
                water?"
              </div>
              <editor v-model="editing.helpText" :init="editorConfig"/>
            </div>

            <mdb-btn @click="savefield" :disabled="!allowSave" color="success" icon="save">Save</mdb-btn>
            <mdb-btn @click="cancelEditing" color="danger" icon="times-circle">Cancel</mdb-btn>
          </mdb-card-body>
        </mdb-card>
      </div>

      <yes-no-modal @yes="doDeleteField" @no="showDeleteModal=false" :additional-text="deleteCandidate.answerCount >1 ? 'All ' + deleteCandidate.answerCount + ' answers will also be deleted. This cannot be undone.' : 'This cannot be undone.'" v-if="showDeleteModal"/>
      <yes-no-modal @yes="doForceReAnswer" @no="showForceModal=false"
                    additional-text=""
                    additional-text="Existing answers will not be deleted, but members will be prompted to review and update their answer."
                    v-if="showForceModal"/>

    </div>
  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import gpSelect from "../common/GPSelect";
import editor from '@tinymce/tinymce-vue'
import YesNoModal from "../common/YesNoModal";
import BannerSmall from "../group/BannerSmall";

import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardFooter,
  mdbCardHeader,
  mdbChipInput,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
  name: "field-designer",
  order: 1,
  components: {
    mdbContainer, mdbTbl, mdbTblHead, mdbTblBody, mdbIcon, mdbBtn, mdbInput,
    mdbCard, mdbCardBody, mdbCardHeader, mdbCardFooter,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbChipInput,
    gpSelect,
    editor,
    YesNoModal,
    BannerSmall
  },
  computed: {
    userMayUpdateLabel() {
      if (this.domainName == "user") return "User may update"
      if (this.domainName == "member") return "Member may update"
      return "Updatable"
    },
    showUserMayUpdate() {
      if (this.domainName == "user" || this.domainName == "member") return true
      return false
    },
    userDetails() {
      return this.$store.state.userDetails
    },
    settings() {
      return this.$store.state.settings
    },
    currentGroup() {
      return this.$store.state.currentGroup
    },
    allowSave() {
      if (this.editing.seqNum === null || this.editing.seqNum === "") return false
      if (this.editing.type == "PICKLIST" && this.editing.pickListValues.length == 0) return false
      if (this.editing.fieldName && this.editing.type && this.editing.seqNum >= 0 ) return true
      return false
    }
  },
  data() {
    return {
      fields: [],
      currentfield: null,
      editing: null,
      deleteCandidate: null,
      showDeleteModal: false,
      showMain: true,
      showEdit: false,
      selectableCountries: [],
      helpText: null,
      showInstructions: false,
      domainName: "",
      domainNameProper: "",
      showWhoCanView: false,
      showForceModal: false,
      pageTitle: "Custom Fields",
      viewers: [
        {text: "Admin Only", value: "ADMIN"},
        {text: "Admins and Organizers", value: "ORGANIZER"},
        {text: "Everyone in Group", value: "MEMBER"}
      ],
      fieldTypes: [
        {text: "Short Text", value: "SHORT_TEXT"},
        {text: "Long Text", value: "LONG_TEXT"},
        {text: "Date", value: "DATE"},
        {text: "Pick List", value: "PICKLIST"},
        {text: "Number (no decimal)", value: "INTEGER"},
        {text: "Number (decimal)", value: "FLOAT"},
        {text: "Acknowledgement", value: "ACKNOWLEDGEMENT"},
        {text: "Checkbox (Yes/No, True/False, etc.)", value: "BOOLEAN"},
        {text: "File", value: "FILE"}
      ],
      groupId: "s", //default for system fields
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["link", "paste"],
        toolbar: ["undo redo cut copy paste bold italic underline | link unlink"],
        image_advtab: false,
        style_formats_merge: true,
        paste_as_text: true,
        paste_data_images: false,
        relative_urls: false,
        remove_script_host: false,
        height: 250
      }
    }
  },
  mounted() {
    let parts = this.$route.path.split("/")
    this.domainName = parts[2]
    this.domainNameProper = this.domainName.replace(/^\w/, (c) => c.toUpperCase())
    this.pageTitle = "Custom " + this.domainNameProper + " Fields"
    document.title = this.pageTitle
    if (this.domainName == "member") {
      this.showWhoCanView = true
      this.helpText = `<p>As an organizer, you may wish to track certain pieces of information (fields) on your members.
            You may track short text, long text, dates, numbers, files and pick lists.</p>
          <p>Examples of some fields other groups track: membership dues paid [number field], membership due date [date
            field], skill level [pick list or text], spouse's name [text], birthdate [date], etc.</p>
          <p>You may also control who sees the field values on the member page: all members, organizers or admins only.</p>
          <p>You can force new members to fill in these fields upon registration. Simply check the "Member May Update" box on a field and be
           sure to include helpful text explaining what you are asking for.</p>
          <p><b><i>You are responsible for adhering to the data collection laws of your country. Do not collect
            information if it not legal to do so.</i></b></p>`
    }
    if (this.$route.params.group) this.groupId = this.$route.params.group
    this.listFields()
  },
  methods: {
    translateFieldType(f) {
      for (let ft of this.fieldTypes) {
        if (ft.value == f) return ft.text
      }
      return "?"
    },
    listFields() {
      this.$store.dispatch("setExecuting", true)
      let url = `/customField/${this.domainName}/${this.groupId}/list`
      if (this.$route.params.id) url += "/" + this.$route.params.id
      api.get(url).then(
        (results) => {
          this.fields = results.data
        },
        (error) => {
          if (error.response.status == 403 || error.response.status == 401) {
            this.$router.push({path: '/403', query: {redirect: this.$route.fullPath}})
            return
          }
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    savefield() {
      this.$store.dispatch("setExecuting", true)
      let url = `/customField/${this.domainName}/${this.groupId}/save`
      if (this.$route.params.id) url += "/" + this.$route.params.id
      api.post(url, this.editing).then(
        (results) => {
          if (!this.editing.id) this.editing.id = results.data.id
          this.$notify.success({message: "Success", timeOut: 2000})
          this.listFields()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    addField() {
      this.editing = {
        id: null,
        fieldName: "",
        seqNum: 100,
        description: "",
        type: "SHORT_TEXT",
        required: false,
        userMayUpdate: false,
        pickListValues: [],
        whoCanView: "ADMIN",
        expireWithSubscription: false
      }
      if (this.domainName == "form") this.editing.userMayUpdate = true
      this.showMain = false
      this.showEdit = true
    },
    deleteField(field) {
      this.deleteCandidate = field
      this.showDeleteModal = true
    },
    forceReAnswer(field) {
      this.deleteCandidate = field
      this.showForceModal = true
    },
    doDeleteField() {
      this.showDeleteModal = false
      this.$store.dispatch("setExecuting", true)
      api.delete(`/customField/${this.domainName}/${this.groupId}/delete/` + this.deleteCandidate.id).then(
        (results) => {
          this.$notify.success({message: "Success", timeOut: 2000})
          this.listFields()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    doForceReAnswer() {
      this.showForceModal = false
      this.$store.dispatch("setExecuting", true)
      api.post(`/customField/${this.domainName}/${this.groupId}/forceReAnswer`, {id: this.deleteCandidate.id }).then(
        (details) => {
          this.deleteCandidate = null
          this.$notify.success({message: "Success!"})
        },
        (error) => {
          this.$notify.error({message: error.response.data})
        }
      ).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },

    editfield(field) {
      this.currentfield = field
      this.editing = JSON.parse(JSON.stringify(field));
      this.showMain = false
      this.showEdit = true
    },
    cancelEditing() {
      this.currentfield = null
      this.editing = null
      this.showMain = true
      this.showEdit = false
    }
  }
};

</script>

